import { render, staticRenderFns } from "./strandedPersonnel.vue?vue&type=template&id=95061ae6&"
import script from "./strandedPersonnel.vue?vue&type=script&lang=js&"
export * from "./strandedPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports